import { render, staticRenderFns } from "./Tecnici.vue?vue&type=template&id=2e8119c4&scoped=true&"
import script from "./Tecnici.vue?vue&type=script&lang=js&"
export * from "./Tecnici.vue?vue&type=script&lang=js&"
import style0 from "./Tecnici.vue?vue&type=style&index=0&id=2e8119c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8119c4",
  null
  
)

export default component.exports